/** @format */

import React from 'react';
import { AvatarContainer } from '../styles';
import avatar from '../../../../../images/img/avatar.svg';

const UserAvatar = ({ handleClick, profileAvatar, aud, ref }) => {
	const { RAZZLE_CDN_URL } = process.env;
	const url = profileAvatar ? profileAvatar : avatar;
	return (
		<AvatarContainer ref={ref} onClick={handleClick}>
			<img
				src={`${RAZZLE_CDN_URL}/member/${aud}/avatar/${url}`}
				width={30}
				height={30}
			/>
		</AvatarContainer>
	);
};

export default React.memo(UserAvatar);
